const key = "fake-business-charges";

const applicable = (resp) => {
	// api/businesses/${businessCode}/fees
	return (resp.config.method === "GET" || resp.config.method === "POST" || resp.config.method === "PUT") 
		&& (resp.config.url.match(/api\/businesses\/[0-9]*\/fees$/) || resp.config.url.match(/api\/businesses\/[0-9]*\/fees\/[0-9]*$/));
};

const modify = (resp) => {
	if(resp.status !== 404 && resp.status !== 403 && resp.status !== 405) {
		throw resp;
	}

	resp.status = 200;
	resp.data.Success = true;
	delete resp.data.Errors;
	delete resp.data.Informations;
	if(resp.config.method === "GET") {
		resp.data.Data = [
			{
				Code: "6230d4e6-bb01-4fcf-8327-f6d13b6037f4",
				Name: "Sales Tax",
				Type: { Code: "PERCENT" },
				Amount: 5.5,
				IsActive: true
			},
			{
				Code: "e38f6658-5bdd-41dc-b48d-457ee013ee76",
				Name: "Slime fee",
				Type:  { Code: "FLAT" },
				Amount: 10.25,
				IsActive: true
			},
			{
				Code: "63fa26fa-9683-4d25-8d2f-9244f75a2ea8",
				Name: "Sales Tax (old)",
				Type: { Code: "PERCENT" },
				Amount: 20.5,
				IsActive: false
			}
		];
	}

	if(resp.config.method === "POST") {
		resp.data.Data = {
			...resp.config?.data,
			Code: "3cfe1b0a-de89-43a2-8794-bd8acd49c3ac"
		};
	}

	if(resp.config.method === "PUT") {
		resp.data.Data = {
			...resp.config?.data
		};
	}

	return resp;
};

export const fakeBusinessCharges = [key, applicable, modify];